import { BatchProcessingStatus } from '../types'

export const isOldBatchRecord = (data: any) => {
  return data.fileSize ? false : true
}

export const isBatchQueued = (data: any) => {
  return data.processingStatus === BatchProcessingStatus.Queued ? true : false
}
